var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "dashboard mx-5",
      attrs: {
        id: "tickets-dashboard",
        fluid: "",
        "fill-height": "",
        "fill-width": ""
      }
    },
    [
      _c(
        "v-row",
        { staticClass: "align-center", attrs: { "no-gutters": "" } },
        [
          _c("v-icon", { staticClass: "mr-4", attrs: { large: "" } }, [
            _vm._v(" mdi-account-tie ")
          ]),
          _c("div", { staticClass: "title-header" }, [
            _vm._v("Accesos al Data Center")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }